import script from "./BpmnDictsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnDictsEditor.vue?vue&type=script&setup=true&lang=js"

import "./BpmnDictsEditor.vue?vue&type=style&index=0&id=eff43a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eff43a54"]])

export default __exports__